const plpCarousel = document.querySelectorAll(".js-product-carousel");
if (plpCarousel.length) {
  plpCarousel.forEach(function (el, index) {
    el.classList.add(`s${index}`);
    new Swiper(`.js-product-carousel.s${index}`, {
      slidesPerView: 'auto',
      spaceBetween: 32,
      initialSlide: 0,
      loop: false,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        0:{
            spaceBetween: 16
        },
        769: {
            spaceBetween: 32
        }
      }
    });
  });
}
